const labels = {
    vi: {
        rowCount: 'Số dòng trên trang: ',
        no: 'STT',
        action: 'Thao tác',
    },
    en: {
        rowCount: 'Line number on page: ',
        no: 'No',
        action: 'Actions',
    },
};

export default labels;
